import {MatchField, MatchType} from "../../../../../../../api/generated";
import {SelectOption} from "../../../../../../elements/select/SelectDropdown";

export const allMatchFieldOptions: SelectOption<MatchField>[] = [
    {
        label: "Derivative",
        value: MatchField.Derivative
    },
    {
        label: "External Stock ID",
        value: MatchField.ExternalStockId
    },
    {
        label: "Keyloop Vehicle ID",
        value: MatchField.KeyloopVehicleId
    },
    {
        label: "Pipeline Stock File Vehicle ID",
        value: MatchField.PipelineStockFileVehicleId
    }
]

export const getMatchFieldName = (matchField: MatchField) => {
    const option = allMatchFieldOptions.filter(o => o.value === matchField)

    if (option && option.length === 1) {
        return option[0].label
    }

    throw new Error(`Unable to handle matchField: ${matchField} correctly`)
}


export const allMatchTypeOptions: SelectOption<MatchType>[] = [
    {
        label: "Exact Match",
        value: MatchType.ExactMatch
    },
    {
        label: "Fuzzy Match",
        value: MatchType.FuzzyMatch
    }
]

export const getMatchTypeName = (matchType: MatchType) => {
    const option = allMatchTypeOptions.filter(o => o.value === matchType)

    if (option && option.length === 1) {
        return option[0].label
    }

    throw new Error(`Unable to handle matchType: ${matchType} correctly`)
}
